/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';
import type { BeamConstancyWorkResultDtoOutput } from './BeamConstancyWorkResultDtoOutput';
import {
    BeamConstancyWorkResultDtoOutputFromJSON,
    BeamConstancyWorkResultDtoOutputFromJSONTyped,
    BeamConstancyWorkResultDtoOutputToJSON,
} from './BeamConstancyWorkResultDtoOutput';
import type { NumericEvaluationResultDto } from './NumericEvaluationResultDto';
import {
    NumericEvaluationResultDtoFromJSON,
    NumericEvaluationResultDtoFromJSONTyped,
    NumericEvaluationResultDtoToJSON,
} from './NumericEvaluationResultDto';
import type { ResultState } from './ResultState';
import {
    ResultStateFromJSON,
    ResultStateFromJSONTyped,
    ResultStateToJSON,
} from './ResultState';

/**
 * 
 * @export
 * @interface BeamConstancyWorkResultDto
 */
export interface BeamConstancyWorkResultDto {
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ResultState}
     * @memberof BeamConstancyWorkResultDto
     */
    state?: ResultState;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoOutput}
     * @memberof BeamConstancyWorkResultDto
     */
    output?: BeamConstancyWorkResultDtoOutput | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof BeamConstancyWorkResultDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkResultDto
     */
    measurementId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkResultDto
     */
    referenceMeasurementId?: string | null;
    /**
     * 
     * @type {Array<NumericEvaluationResultDto>}
     * @memberof BeamConstancyWorkResultDto
     */
    evaluationResults?: Array<NumericEvaluationResultDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkResultDto
     */
    $type?: BeamConstancyWorkResultDtoTypeEnum;
}


/**
 * @export
 */
export const BeamConstancyWorkResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoBeamConstancyWorkResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamConstancyWorkResultDtoTypeEnum = typeof BeamConstancyWorkResultDtoTypeEnum[keyof typeof BeamConstancyWorkResultDtoTypeEnum];


/**
 * Check if a given object implements the BeamConstancyWorkResultDto interface.
 */
export function instanceOfBeamConstancyWorkResultDto(value?: unknown): value is BeamConstancyWorkResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamConstancyWorkResultDtoTypeEnum)[0];
}

export function BeamConstancyWorkResultDtoFromJSON(json: any): BeamConstancyWorkResultDto {
    return BeamConstancyWorkResultDtoFromJSONTyped(json, false);
}

export function BeamConstancyWorkResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'state': !exists(json, 'state') ? undefined : ResultStateFromJSON(json['state']),
        'output': !exists(json, 'output') ? undefined : BeamConstancyWorkResultDtoOutputFromJSON(json['output']),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'measurementId': !exists(json, 'measurementId') ? undefined : json['measurementId'],
        'referenceMeasurementId': !exists(json, 'referenceMeasurementId') ? undefined : json['referenceMeasurementId'],
        'evaluationResults': !exists(json, 'evaluationResults') ? undefined : (json['evaluationResults'] === null ? null : (json['evaluationResults'] as Array<any>).map(NumericEvaluationResultDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function BeamConstancyWorkResultDtoToJSON(value?: BeamConstancyWorkResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'state': ResultStateToJSON(value.state),
        'output': BeamConstancyWorkResultDtoOutputToJSON(value.output),
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.creatorUser),
        'measurementId': value.measurementId,
        'referenceMeasurementId': value.referenceMeasurementId,
        'evaluationResults': value.evaluationResults === undefined ? undefined : (value.evaluationResults === null ? null : (value.evaluationResults as Array<any>).map(NumericEvaluationResultDtoToJSON)),
        '$type': value.$type,
    });
}

